import { Component, inject } from '@angular/core'
import { ZardDialogRef, Z_MODAL_DATA } from '@/styles/components/dialog'
import { IErrorDialogData } from '../../models/dialog.models'
import { ICON_PATHS } from '../../../core/constants/assets.constants'
import { BUTTON_TEXT, DEFAULT_DIALOG_TEXTS } from '../../../core/constants/button-text.constants'

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent {
    dialogRef = inject<ZardDialogRef<ErrorDialogComponent>>(ZardDialogRef)
    data = inject<IErrorDialogData>(Z_MODAL_DATA)

    iconPaths = ICON_PATHS
    buttonText = BUTTON_TEXT
    defaultTexts = DEFAULT_DIALOG_TEXTS

    handleConfirmClick(): void {
        this.dialogRef.close(true)
    }
}
